import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const BillingInformation = ({ order }: any) => (
  <div id="billing info & medicare">
    <CustomText
      text="Billing Information"
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    <div className="reviewCard">
      {order?.testType?.test === 8 ? (
        <DetailRenderer
          data={order.billingInfoIDG}
          groupFields={[
            "primaryDiagnosedICD10",
            "additionalDiagnosedICD10",
            "primaryInsurance",
            "insuranceCompanyName",
            "policyNumber",
            "phone",
          ]}
          hiddenFields={[]}
          MainHeading="Billing Information"
          approval
          approvalSectionUrl={`/access/online-order/${order.supportingSection.id}#Billing%20Information`}
        />
      ) : (
        <DetailRenderer
          data={order.billingInfo}
          groupFields={[
            "icd10",
            "primaryInsurance",
            "insuranceCompanyName",
            "policyNumber",
            "phone",
            "typeOfFacility",
            "dateOfDischarge",
          ]}
          hiddenFields={[]}
          MainHeading="Billing Information"
          approval
          approvalSectionUrl={`/access/online-order/${order.supportingSection.id}#Billing%20Information`}
        />
      )}
    </div>
  </div>
);

export default BillingInformation;